
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import 'lodash/isEqual';
import 'just-kebab-case';
import './labels-mixin.js';
import 'focus-visible/dist/focus-visible.js';
import { _ as _objectSpread } from './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import './pendo-icon.js';
import 'vue';
import 'lodash/get';
import './pendo-loading-mixin.js';
import './pendo-loading-indicator.js';
import PendoButton from './pendo-button.js';
import 'v-tooltip';
import './tooltip-mixin.js';
import PendoTooltip from './pendo-tooltip.js';
import isPlainObject from 'lodash/isPlainObject';

var script = {
  name: 'PendoIconButton',
  components: {
    PendoButton
  },
  directives: {
    PendoTooltip
  },
  inheritAttrs: false,
  props: {
    icon: {
      type: String,
      default: null
    },
    iconSize: {
      type: [String, Number],
      default: '16'
    },
    tooltip: {
      type: [String, Object],
      default: null
    }
  },
  computed: {
    tooltipConfig() {
      const defaults = {
        delay: {
          show: 300,
          hide: 0
        }
      };

      if (this.tooltip && isPlainObject(this.tooltip)) {
        return _objectSpread({}, defaults, this.tooltip);
      }

      return _objectSpread({}, defaults, {
        content: this.tooltip
      });
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('pendo-button', _vm._g(_vm._b({
    directives: [{
      name: "pendo-tooltip",
      rawName: "v-pendo-tooltip",
      value: _vm.tooltipConfig,
      expression: "tooltipConfig"
    }],
    staticClass: "pendo-icon-button",
    attrs: {
      "icon": _vm.icon,
      "icon-size": _vm.iconSize
    }
  }, 'pendo-button', _vm.$attrs, false), _vm.$listeners));
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-icon-button.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var PendoIconButton = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default PendoIconButton;
